<template>
  <div class="faqContainer">
    <div class="header">
      <div class="content">
        <Select
          :selectOptions="options"
          placeholder="FAQ"
          :icon="'icon_expand_more_lightgrey'"
          :border="{color:'borderGrey',top:true,bottom:true}"
          v-model="activeFAQOption"
          @change="setActiveFAQOption"
        />
      </div>
      <div class="close selfAlignCenter" @click="closeSidebar">
        <SVGIcon name="close" size="small" class="cursor-pointer"/>
      </div>
    </div>

    <div class="faqContent">
      <FAQHaeufigeFragen v-if="activeFAQOption=== 'Häufige Fragen'"/>
      <FAQFunktionen v-if="activeFAQOption === 'Funktionen'"/>
      <FAQAllgemeines v-if="activeFAQOption === 'Allgemeines'"/>
    </div>
  </div>
</template>

<script>
import Select from "./../CoreComponents/Select.vue";
import FAQHaeufigeFragen from "./FAQs/HaeufigeFragen.vue";
import FAQFunktionen from "./FAQs/Funktionen.vue";
import FAQAllgemeines from "./FAQs/Allgemeines.vue";

export default {
  name: "FAQ",
  components: {
    Select,
    FAQHaeufigeFragen,
    FAQFunktionen,
    FAQAllgemeines
  },
  data: function() {
    return {
      options: ["Häufige Fragen", "Funktionen", "Allgemeines"],
      activeFAQOption: "Häufige Fragen"
    };
  },
  computed: {
    device() {
      return this.$store.state.device;
    }
  },
  methods: {
    closeSidebar() {
      this.$emit("close");
    },
    setActiveFAQOption(value) {
      this.activeFAQOption = value;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.faqContainer {
  width: 100%;
  height: calc(100% - 108px);
}
.header {
  width: 100%;
  display: flex;
  margin-bottom: 30px;
}

.content,
.faqContent {
  width: calc(10.75 / 12 * 100%);
}

.close {
  width: calc(1.25 / 12 * 100%);
  padding-right: 15px;
  padding-left: 15px;
  text-align: right;
}

.faqContent {
  height: 100%;
  overflow-y: auto;
}
</style>
